/** Wording for the Customer service card on Activity (ServicePanel.tsx). */

/** 27816 → '7h 43m'; under an hour in minutes, two days and over in days. */
export function fmtDuration(seconds: number): string {
  const m = Math.floor(seconds / 60)
  if (m < 60) return `${Math.max(m, 1)}m`
  const h = Math.floor(m / 60)
  if (h < 48) return m % 60 ? `${h}h ${m % 60}m` : `${h}h`
  return `${Math.floor(h / 24)} days`
}

export const fmtPct = (share: number): string => `${Math.round(share * 100)}%`

/** 'up from 81%' / 'down from 81%' / 'same as before'; '' with nothing to compare. */
export function moved<T extends number>(cur: T | null, prev: T | null, fmt: (v: T) => string): string {
  if (cur === null || prev === null) return ''
  if (fmt(cur) === fmt(prev)) return 'same as before'
  return `${cur > prev ? 'up' : 'down'} from ${fmt(prev)}`
}

/** Share answered within a day, or null when nothing could have been answered yet. */
export const withinDay = (t: { reply_base: number; within_day: number }): number | null =>
  t.reply_base ? t.within_day / t.reply_base : null

/** How long the oldest waiting message has waited: 'today', '1 day', '12 days'. */
export function waited(oldestAt: string, now: Date = new Date()): string {
  const days = Math.floor((now.getTime() - new Date(oldestAt).getTime()) / 86_400_000)
  return days < 1 ? 'today' : days === 1 ? '1 day' : `${days} days`
}

/** Bar widths in % for a stacked bar; zero parts drop out. */
export function stack<K extends string>(parts: { key: K; n: number }[]): { key: K; n: number; pct: number }[] {
  const total = parts.reduce((a, p) => a + p.n, 0)
  return total ? parts.filter((p) => p.n > 0).map((p) => ({ ...p, pct: (p.n / total) * 100 })) : []
}
